module.exports = __webpack_public_path__ + "01_short_grey.9b0554bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/01_short_grey.png
// module id = 8Wcu
// module chunks = 0